import * as React from "react";

import { FileSuccessful } from "../FileSuccessful/FileSuccessful";

import type { FileProps } from "./File.props";

const File = ({ value, onChange, isLoading, accept = "", disabled }: FileProps) => {
	if (value?.url && !isLoading) {
		return <FileSuccessful file={value} />
	}

	return (
		<div className="form-control">
			{isLoading ? (
				<span>Файл сохраняется...</span>
			) : (
				<label className="file-load" style={{ cursor: "pointer" }}>
					<input
						type="file"
						className="file-load__input"
						accept={accept}
						onChange={onChange}
						disabled={disabled}
					/>
					<button type="button" role="button" className="file-load__button">Выбрать файлы</button>
				</label>
			)}
		</div>
	);
};

export { File };
